import type { ReactElement } from 'react';

import type { CommonFlightsInlineCreative } from '../commonFlightsInlineAdTypes';

import STYLES from './Logo.module.scss';

const LOGO_DOMAIN = '//www.skyscanner.net';

type BrandLogoBlockProps = {
  creative: CommonFlightsInlineCreative;
  isInline: boolean;
};

function getSrc(creative: CommonFlightsInlineCreative, isInline: boolean) {
  const { partner, partnerDesktopLogo, partnerLogo } = creative;

  if (isInline) {
    return partnerDesktopLogo || (partner ? `${LOGO_DOMAIN}/images/websites/${partner}.png` : null);
  }

  return partnerLogo || (partner ? `${LOGO_DOMAIN}/images/websites/bar/${partner}.png` : null);
}

const Logo = ({ creative, isInline }: BrandLogoBlockProps): ReactElement | null => {
  const imageSrc = getSrc(creative, isInline);

  // Should never happen if campaign is set up correctly
  if (!imageSrc) {
    return null;
  }

  return <img src={imageSrc} className={STYLES.logo} data-testid="brand-logo" alt="" aria-hidden />;
};

export default Logo;
